<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">商品情報</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h2>商品一覧</h2>
          <wj-flex-grid [itemsSource]="kymw1406Model.goodsInfoList" id="dtg_GoodsInfo" #dtg_GoodsInfo
            [allowResizing]="true" [allowSorting]="true" [headersVisibility]="'Column'" [allowDragging]="'None'"
            [selectionMode]="'Row'" forcedEnabledMode="true" [tabindex]="0" (pasting)="onPasting($event)">
            <wj-flex-grid-column [minWidth]="5" [width]="90" [header]="'Seq.NO'" [binding]="'OrderNumSeqNo'"
              [isReadOnly]="kymw1406Model.editMode === EDIT_MODE_READONLY">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <label [style.width.%]="100" [style.padding.px]="3" [style.margin-left.px]="-3"
                  [style.margin-top.px]="-3" [style.margin-bottom.px]="0">{{cell.item.OrderNumSeqNo}}</label>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" class="wj-grid-editor" [style.width.%]="100" [style.margin-left.px]="-3"
                  autocomplete="off" [style.margin-top.px]="-3" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                  [(ngModel)]="cell.item.OrderNumSeqNo" [tabindex]="-1"
                  (keydown)="eventGridKeyDownHandler($event,dtg_GoodsInfo,0)" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'Ｐコード'" [binding]="'PCode'" [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'アイテムコード'" [binding]="'ItemCode'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="172" [header]="'商品名'" [binding]="'GuideGoodsName'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'規格名'" [binding]="'GuideStandardName'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'今回供給価格'" [binding]="'ThisTimeSupplyPrice'"
              [isReadOnly]="true" [align]="'right'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="90" [header]="'注文コード'" [binding]="'OrderNum'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>

        <div>
          <h2>商品属性情報</h2>
          <wj-flex-grid class="grid-goods-attrib" [itemsSource]="kymw1406Model.goodsDetailList" id="dtg_GoodsAttribute"
            #dtg_GoodsAttribute [deferResizing]="false" [allowSorting]="true" [headersVisibility]="'None'"
            [allowDragging]="'None'" [selectionMode]="'Row'" [isReadOnly]="true" [tabindex]="0">
            <wj-flex-grid-column [minWidth]="5" [width]="190" [header]="''" [binding]="'lbl'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="635" [header]="''" [binding]="'data'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>

        <div>
          <h2>コマ補足情報</h2>
          <div class="column-list">
            <label class="list-input-title">コマコメント</label>
            <div class="list-input-content">
              <app-text-area id="KomaComment" #KomaComment [subid]="'KomaComment'" [restrict]="'[ -￮]'" [maxChars]="100"
                [displayCountField]="false" [(ngModel)]="kymw1406Model.komaComment" [fullOnly]="true"
                [disabled]="kymw1406Model.disabledKomaComment" [tabindex]="0">
              </app-text-area>
            </div>
            <label class="list-input-title">コマパターン</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_KomaPatternDiv" #cmb_KomaPatternDiv [subid]="'cmb_KomaPatternDiv'"
                [codeDiv]="'ct351'" [forcedEnabledMode]="'true'"
                [disabled]="kymw1406Model.disabledKomaPatternDiv" [tabindex]="0"></app-code-combo-box>
            </div>
            <label class="list-input-title">価値コマコメント</label>
            <div class="list-input-content">
              <app-text-area id="ValueKomaComment" #ValueKomaComment [subid]="'ValueKomaComment'" [restrict]="'[ -￮]'"
                [maxChars]="100" [displayCountField]="false" [(ngModel)]="kymw1406Model.valueKomaComment" [fullOnly]="true"
                [disabled]="kymw1406Model.disabledValueKomaComment" [tabindex]="0">
              </app-text-area>
            </div>
          </div>
        </div>

        <div>
          <h2>表組情報</h2>
          <div class="column-list">
            <label class="list-input-title">表組パターン</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_ListingPatternID" #cmb_ListingPatternID [subid]="'cmb_ListingPatternID'"
                [codeDiv]="'ctp007'" [forcedEnabledMode]="'true'" [disabled]="kymw1406Model.disabledListingPatternID"
                [tabindex]="0">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">表組用商品名</label>
            <div class="list-input-content">
              <select id="cmb_ListingGoodsName" [(ngModel)]="kymw1406Model.listingGoodsName" forcedEnabledMode="true"
                [disabled]="kymw1406Model.disabledListingGoodsName" [tabindex]="0">
                <ng-template ngFor let-item [ngForOf]="kymw1406Model.listingGoodsNameList">
                  <option value="{{item.code}}">{{item.name}}</option>
                </ng-template>
              </select>
            </div>
          </div>
        </div>

        <div>
          <h2>クロス設定情報</h2>
          <div class="column-list">
            <div class="list-input-title layout_balance">
              <label>商品説明文</label>
              <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                  <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-area id="txta_CrossGoodsExplanation" #txta_CrossGoodsExplanation
                [subid]="'txta_CrossGoodsExplanation'" [restrict]="'[ -￮]'" [maxChars]="200" [displayCountField]="false"
                [(ngModel)]="kymw1406Model.crossSetting.goodsExplanation" [fullOnly]="true"
                [disabled]="kymw1406Model.disabledCrossGoodsExplanation" [tabindex]="0" height="100px">
              </app-text-area>
            </div>
            <div class="list-input-title layout_balance">
              <label>キャッチコピー</label>
              <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-area id="txta_CrossCatchCopy" #txta_CrossCatchCopy [subid]="'txta_CrossCatchCopy'"
                [restrict]="'[ -￮]'" [maxChars]="200" [displayCountField]="false" [fullOnly]="true"
                [(ngModel)]="kymw1406Model.crossSetting.catchCopy" [disabled]="kymw1406Model.disabledCrossCatchCopy"
                [tabindex]="0" height="100px">
              </app-text-area>
            </div>
          </div>
        </div>

        <div>
          <h2>マルチ設定情報</h2>
          <div class="column-list">
            <div class="list-input-title layout_balance">
              <label>商品説明文</label>
              <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-area id="txta_MultiGoodsExplanation" #txta_MultiGoodsExplanation
                [subid]="'txta_MultiGoodsExplanation'" [restrict]="'[ -￮]'" [maxChars]="200" [displayCountField]="false"
                [(ngModel)]="kymw1406Model.multiSetting.goodsExplanation" [fullOnly]="true"
                [disabled]="kymw1406Model.disabledMultiGoodsExplanation" [tabindex]="0" height="100px">
              </app-text-area>
            </div>
            <div class="list-input-title layout_balance">
              <label>キャッチコピー</label>
              <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-area id="txta_MultiCatchCopy" #txta_CrossCatchCopy [subid]="'txta_MultiCatchCopy'"
                [restrict]="'[ -￮]'" [maxChars]="200" [displayCountField]="false" [fullOnly]="true"
                [(ngModel)]="kymw1406Model.multiSetting.catchCopy" [disabled]="kymw1406Model.disabledMultiCatchCopy"
                [tabindex]="0" height="100px">
              </app-text-area>
            </div>
          </div>
        </div>

      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Regist" class="btn-primary" [disabled]="kymw1406Model.disabledRegist"
            (click)="eventRegist_CLICKHandler()" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>